<div class="add-picture-field" *ngIf="uploadFilePath">
  <div class="pictures">
    <ng-container *ngIf="imagesWithSize.length + imagesToUpload.length > 0">
      <div class="picture-wrapper" *ngFor="let image of imagesWithSize; let i = index">
        <app-image-preview-item
          [photoPath]="image.storagePath"
          [size]="image.size"
          [removeButton]="!disabled"
          [colors]="!!color ? color === 'offers' ? ColorSchemes.OFFERS : ColorSchemes.PRIMARY : colors"
          (onRemove)="removeFile(i, false)"
        ></app-image-preview-item>
      </div>
      <div class="picture-wrapper" *ngFor="let image of imagesToUpload; let i = index">
        <app-image-preview-item
          [rawData]="image.rawData"
          [size]="image.size"
          [removeButton]="!disabled"
          [colors]="!!color ? color === 'offers' ? ColorSchemes.OFFERS : ColorSchemes.PRIMARY : colors"
          (onRemove)="removeFile(i, true)"
        ></app-image-preview-item>
      </div>
    </ng-container>
  </div>
  <app-file-input
    *ngIf="!disabled && imagesCount < maxImages"
    [extensions]="['.png', '.jpg', '.jpeg', '.gif']"
    [fileSizeMB]="fileSizeLimit / 1000000"
    [mimeTypes]="mimeTypes"
    [multiple]="maxImages > 1 && !withCropper"
    (filesAdded)="addFiles($event)"
    color="primary"
  >
    <ng-template #icon>
      <app-add-picture-icon [color]="color"></app-add-picture-icon>
    </ng-template>
    <ng-template #footer *ngIf="maxImages > 1">
      <div footer>({{ 'label.max' | loc }} {{ maxImages }})</div>
    </ng-template>
  </app-file-input>
  <mat-error *ngIf="maxCountExceeded">
    {{ 'attachment.maxCountError' | locRep: { $max: maxImages } }}
  </mat-error>
</div>
